import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveJobLabor = async (jobLabor, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        jobLaborID: jobLabor.jobLaborID,
        jobID: jobLabor.jobID,
        skillID: jobLabor.skillID,
        employeeID: jobLabor.employeeID,
        teamID: jobLabor.teamID,
        budgetedCostPerHour: jobLabor.budgetedCostPerHour,
        budgetedPricePerUnit: jobLabor.budgetedPricePerUnit,
        budgetedHours: jobLabor.budgetedHours,
        budgetedMarkup: jobLabor.budgetedMarkup,
        actualCostPerHour: jobLabor.actualCostPerHour,
        actualPricePerUnit: jobLabor.actualPricePerUnit,
        actualHours: jobLabor.actualHours,
        actualMarkup: jobLabor.actualMarkup,
        providedBy: jobLabor.providedBy,
        sortOrder: jobLabor.sortOrder,
        notes: jobLabor.notes
      };
      const response = await fetch(`${dev_baseUrl}/JobLabor/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else{
        return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
